module.exports = __webpack_public_path__ + "static/media/Detectives ID.807d66dc.jpg";